import { Controller } from "@hotwired/stimulus"
import L from "leaflet"

export default class extends Controller {
  static targets = ["map", "coordinates", "hint", "radius"]
  static values = {
    radius: { type: Number, default: 0 },
    center: Array
  }

  connect() {
    this._clickMarker = null
    this._circle = null
    this._currentCenter = null
    this._boundClick = this._onMapClick.bind(this)
    setTimeout(() => this._drawInitialCircle(), 0)
  }

  disconnect() {
    this._leafletMap()?.off("click", this._boundClick)
  }

  startPicking() {
    if (!this.hasMapTarget) return

    const lmap = this._leafletMap()
    if (!lmap) return

    lmap.on("click", this._boundClick)
    this.mapTarget.style.cursor = "crosshair"


    if (this.hasHintTarget) {
      this.hintTarget.classList.remove("d-none")
    }
  }

  _onMapClick(e) {
    const round = (n) => Math.round(n * 1000000) / 1000000
    const lat = round(e.latlng.lat)
    const lng = round(e.latlng.lng)

    if (this._clickMarker) {
      this._clickMarker.setLatLng(e.latlng)
    } else {
      const icon = L.divIcon({
        className: "custom-marker-pin",
        html: `<svg width="100%" height="100%" viewBox="0 0 24 32" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 0C5.383 0 0 5.383 0 12c0 9 12 20 12 20s12-11 12-20C24 5.383 18.617 0 12 0z" fill="#f59e0b" stroke="#000" stroke-width="1"/>
        </svg>`,
        iconSize: [24, 32],
        iconAnchor: [12, 32]
      })
      this._clickMarker = L.marker(e.latlng, { icon, draggable: true })
        .addTo(this._leafletMap())

      this._clickMarker.on("dragend", (ev) => {
        const pos = ev.target.getLatLng()
        this._setCoordinates(round(pos.lat), round(pos.lng))
      })
    }

    this._setCoordinates(lat, lng)
  }

  _setCoordinates(lat, lng) {
    this.coordinatesTarget.value = `${lat}, ${lng}`
    this.coordinatesTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this._drawCircle([lat, lng], this._effectiveRadius())
  }

  updateRadius() {
    if (!this._currentCenter) return
    this._drawCircle(this._currentCenter, this._effectiveRadius())
  }

  _effectiveRadius() {
    if (!this.hasRadiusTarget) return this.radiusValue
    const val = parseInt(this.radiusTarget.value, 10)
    return isNaN(val) || val <= 0 ? 100 : val
  }

  _drawInitialCircle() {
    if (!this.hasMapTarget || !this.hasCenterValue) return
    const [lat, lng] = this.centerValue
    if (lat == null || lng == null) return
    this._drawCircle([lat, lng])
  }

  _drawCircle(coords, radius = this.radiusValue) {
    this._currentCenter = coords
    if (!radius || !this.hasMapTarget) return
    const lmap = this._leafletMap()
    if (!lmap) return

    if (this._circle) this._circle.remove()
    this._circle = L.circle(coords, {
      radius,
      color: "#3b82f6",
      weight: 2,
      dashArray: "6 4",
      fillColor: "#3b82f6",
      fillOpacity: 0.08
    }).addTo(lmap)
  }

  _leafletMap() {
    return this.application
      .getControllerForElementAndIdentifier(this.mapTarget, "leaflet-map")
      ?.map
  }
}
